import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PackagingMachinesService {

  constructor(
    private http: HttpClient
  ) { }

  getPackagingMachines() {
    return (this.http.get(`${environment.apiUrl}/packaging-machine`));
  }

  createPackagingMachine(data: any) {
    return (this.http.post(`${environment.apiUrl}/packaging-machine`, data));
  }

  getPackagingMachineById(id: number) {
    return (this.http.get(`${environment.apiUrl}/packaging-machine/${id}`));
  }

  updatePackagingMachine(data: any) {
    return (this.http.put(`${environment.apiUrl}/packaging-machine/${data.id}`, data));
  }

  deletePackagingMachine(id: number) {
    return (this.http.delete(`${environment.apiUrl}/packaging-machine/${id}`));
  }
}
